import React, { ChangeEvent, useEffect, useRef } from 'react';

import { StyledCheckbox } from '../BlueTheme/StyledCheckbox/styled';
import { CheckboxWrapper } from './styled';

type Props = {
  dataTestid?: string;
  checked?: boolean;
  indeterminate?: boolean;
  disabled?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  className?: string;
};

const IndeterminateCheckbox = ({
  dataTestid = 'indeterminateCheckbox',
  indeterminate,
  onChange,
  checked,
  disabled,
  className,
}: Props): JSX.Element => {
  const ref = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (ref.current) {
      ref.current.indeterminate = indeterminate || false;
    }
  }, [indeterminate]);

  return (
    <CheckboxWrapper className={className} data-testid={dataTestid}>
      <StyledCheckbox ref={ref} checked={checked} onChange={onChange} disabled={disabled} />
    </CheckboxWrapper>
  );
};

export default IndeterminateCheckbox;
